import { defineStore } from "pinia";
import { ref } from "vue";


export const useStatsCompareStore = defineStore('useStatsCompareStore', () => {
    const isComparePeriod = ref<boolean>(false);
    const currentDate = ref<string[]>([]);
    const compareDate = ref<string[]>([]);

    return {
        isComparePeriod,
        currentDate,
        compareDate,
    };
});
